import styled from 'styled-components';
import { colors, media } from '@prisjakt/ui-base';

export const applyFilterAreaHeight = 90;

export const ApplyFilterArea = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.semiWhite};
  width: 100%;
  padding: 10px;
  border-top: 1px solid ${p => p.theme.lines.secondary};
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4);

  /* Set explicit height in order to account for that height in the wrapper */
  height: ${applyFilterAreaHeight}px;

  ${media.largeUp`
    display: none;
  `}
`;

export const ProductCount = styled.div`
  color: ${colors.darkGray4};
  margin-bottom: 10px;
`;
